import { h, render, Component } from 'preact';
import { classNames} from '../utils/utils';

class TxrRadioButton extends Component {
    state = {
    }
     txrEdit = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }
 

    render() {
        return (
            <div class="txr-radio-button">
                <div class="txr-radio-button__container">
                    <input type="radio" id={this.props.group + this.props.value} onClick={(e) => this.txrEdit(e)} class="txr-radio" name={this.props.group} value={this.props.value} checked={this.props.value === this.props.model.value} />
                    <label for={this.props.group + this.props.value}>{this.props.caption}</label>
                </div>
            </div>
        )
    }
}
export default TxrRadioButton;